/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 优秀合作案例
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';

export class GoodCaseController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.content_goodcase_pagelist, // usersvr_bizNews
      // pagination: EnumAPI.usersvr_bizNews,
      // details: EnumAPI.content_goodcase_detail,
      details: EnumAPI.content_goodcase_detail,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: {
          dataSource: 'data',
          total: 'total',
          // valueGetter: (res) => {
          //   return {
          //     dataSource: caseList,
          //     total: lodash.get(res, 'count', 3),
          //   };
          // },
        },
      },
    });
  }
  //

  /**
   * 值存储
   * @memberof MaterialsController
   */
  Model = new BaseModel({ type: 'object' });

  /**
   * @dec 首页优秀合作案例
   */
  @computed
  get caseList(): Array<IEntity> {
    return this.Model.get('caseList', []);
  }
  // get total() {
  //   return this.Model.get('total', 0);
  // }
  /**
   * @dec 优秀合作案例 查询条件
   */
  @computed
  get tabList(): Array<ITag> {
    return this.Model.get('tabList', []);
  }

  /**
   * @dec 优秀合作案例 选中的查询条件
   */
  @computed
  get searchTagInfo(): Array<any> {
    return this.Model.get('searchTagInfo', []);
  }

  /**
   * 获取 优秀合作案例 list
   */
  async getGoodCaseList() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.content_goodcase_pagelist,
        cache: true,
        body: {
          pageSize: 3,
          curPageNo: 1,
          search: {
            nsectiononeId: 'A009',
          },
        },
      });
      console.log('～～zy～～ ~ res getGoodCaseList', res);
      // this.Model.merge({ caseList: lodash.get(res, 'data') });
      this.Model.merge({ caseList: lodash.get(res, 'data') });
    } catch (error) {}
  }

  // 转化 后台需要的 查询参数
  covertSearchParam(query) {
    const keys = lodash.map(this.tabList, 'id');
    const searchInfo: ISearchInfo = lodash.pick(query, [
      'timeSort',
      'pvSort',
      'keyWord',
    ]);
    const labelSeach = lodash.pickBy(lodash.pick(query, keys), lodash.identity);
    if (!lodash.isEmpty(labelSeach)) {
      const labelIds = lodash.map(Object.keys(labelSeach), (item) => {
        return {
          id: item,
          labelIdList: [labelSeach[item]],
        };
      });
      searchInfo.labelIds = labelIds;
    }
    const body: any = lodash.pickBy(searchInfo, lodash.identity);
    body.nsectiononeId = 'A009';
    const data = {
      current: lodash.defaultTo(lodash.get(searchInfo, 'current'), 1),
      pageSize: lodash.defaultTo(lodash.get(searchInfo, 'pageSize'), 12),
      body,
    };
    return data;
  }

  // 根据搜索条件的v不同获取 list
  onLoadBySearch(query) {
    const data = this.covertSearchParam(query);
    console.log('～～zy～～ ~ data', data);
    this.Pagination.onLoad(data);
  }

  /**
   * 获取 优秀合作案例 查询条件
   */
  async getGoodCaseSearchTabs() {
    try {
      const res: Array<any> = await AjaxBasics.request({
        ...EnumAPI.content_goodcase_labellist,
      });
      const firstInfo = lodash.get(res, '[0].labelList[0]');
      if (lodash.get(firstInfo, 'id') === lodash.get(res, '[0].id')) {
        return this.Model.merge({ tabList: this.tabList });
      }
      let tabList = lodash.map(res, (item) => {
        const all = {
          labelName: '全部',
          id: item.id,
        };
        item.labelList ? item.labelList.unshift(all) : (item.labelList = []);
        return item;
      });
      this.Model.merge({ tabList });
    } catch (error) {
      console.log('～～zy～～ ~ error', error);
    }
  }
}

interface ITag {
  bu: string;
  id: string;
  isEnable: string;
  labelName: string;
  labelCode: string;
  labelList: Array<Object>;
  // type: string;
  // key: string;
  // children: Array<Object>;
  // "labelList": [
  //   {
  //     "bu": "string",
  //     "createBy": "string",
  //     "createTime": "2022-09-21T08:00:37.748Z",
  //     "delFlag": 0,
  //     "id": "string",
  //     "labelCode": "string",
  //     "labelName": "string",
  //     "modifyBy": "string",
  //     "modifyTime": "2022-09-21T08:00:37.748Z"
  //   }
  // ],
}

interface ISearchInfo {
  timeSort?: string | string[] | undefined;
  pvSort?: string | string[] | undefined;
  keyWord?: string | string[] | undefined;
  labelIds?: Array<any>;
}
interface IEntity {
  beginTime: string;
  columnType: string;
  createBy: string;
  createBy1: string;
  createTime: string;
  createTime1: string;
  currentUser: string;
  dataScope: string;
  delFlag: string;
  delFlag1: string;
  endTime: string;
  id: string;
  idType: string;
  modifyBy: string;
  modifyTime: string;
  modifyTime1: string;
  ncontent: string;
  nfiles: string;
  nfilesWatermark: string;
  nistop: number;
  nlabels: string;
  nsectiononeId: string;
  nsectiononeName: string;
  nsectionthreeId: string;
  nsectionthreeName: string;
  nsectiontwoId: string;
  nsectiontwoName: string;
  nstatus: number;
  nsubtitle: string;
  nthumbnailImage: string;
  nthumbnailImagepc: string;
  ntitle: string;
  remarks: string;
  stringList: string;
}
